<template lang="html">

    <section class="wrapper legal">

        <div class="container">
            <div class="loading" v-if="loading"></div>
            <div id="texto"></div>

        </div>

    </section>

</template>

<script lang="js">

    import { mapActions } from 'vuex';
    import router from '@/router';

    export default {
        name: 'politica-privacidad',
        data() {
            return {
                loading : true
            }
        },
        mounted() {
            this.requestAvisoLegal().then(r => {
                var xmlString = r;
                var doc = new DOMParser().parseFromString(xmlString, "text/html");
                console.log(doc);
                var content = doc.querySelector(".container.white.padding");


                document.querySelector("#texto").appendChild(content);
                this.loading = false;
            });
        },
        methods: {
            ...mapActions(['requestAvisoLegal'])
        }


    }
</script>

<style scoped lang="scss">
    .error-404 {}
</style>


// WEBPACK FOOTER //
// src/components/views/aviso-legal.vue